export var Radar_ErrCode = function () {
  //__ENUM_IIFE__
  var Radar_ErrCode;

  (function (Radar_ErrCode) {
    Radar_ErrCode[Radar_ErrCode["Success"] = 0] = "Success";
    Radar_ErrCode[Radar_ErrCode["ErrConfigNotFound"] = 460001] = "ErrConfigNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrMaterialNotFound"] = 460002] = "ErrMaterialNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrCategoryNotFound"] = 460003] = "ErrCategoryNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrVisitStatNotFound"] = 460004] = "ErrVisitStatNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrVisitUserStatNotFound"] = 460005] = "ErrVisitUserStatNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrVisitUserNotFound"] = 460006] = "ErrVisitUserNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrUnKnownEventType"] = 460007] = "ErrUnKnownEventType";
    Radar_ErrCode[Radar_ErrCode["ErrRadarEventNotFound"] = 460008] = "ErrRadarEventNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrTriggerLogNotFound"] = 460009] = "ErrTriggerLogNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrUserDayStatNotFound"] = 460010] = "ErrUserDayStatNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrVisitDayStatNotFound"] = 460011] = "ErrVisitDayStatNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrVisitHourStatNotFound"] = 460012] = "ErrVisitHourStatNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrUserHourStatNotFound"] = 460013] = "ErrUserHourStatNotFound";
    Radar_ErrCode[Radar_ErrCode["ErrGetHourStatErr"] = 460014] = "ErrGetHourStatErr";
    Radar_ErrCode[Radar_ErrCode["ErrStatNotFound"] = 460015] = "ErrStatNotFound";
  })(Radar_ErrCode || (Radar_ErrCode = {}));

  return Radar_ErrCode;
}(); // @desc: 雷达素材类型

export var Radar_MaterialType = function () {
  //__ENUM_IIFE__
  var Radar_MaterialType;

  (function (Radar_MaterialType) {
    Radar_MaterialType[Radar_MaterialType["MaterialTypeNil"] = 0] = "MaterialTypeNil";
    Radar_MaterialType[Radar_MaterialType["MaterialTypeWebPage"] = 1] = "MaterialTypeWebPage";
    Radar_MaterialType[Radar_MaterialType["MaterialTypeArticle"] = 2] = "MaterialTypeArticle";
    Radar_MaterialType[Radar_MaterialType["MaterialTypeVideo"] = 3] = "MaterialTypeVideo";
    Radar_MaterialType[Radar_MaterialType["MaterialTypePDF"] = 4] = "MaterialTypePDF";
    Radar_MaterialType[Radar_MaterialType["MaterialTypeProduct"] = 5] = "MaterialTypeProduct";
  })(Radar_MaterialType || (Radar_MaterialType = {}));

  return Radar_MaterialType;
}(); // @desc: 雷达事件类型

export var Radar_RadarEventType = function () {
  //__ENUM_IIFE__
  var Radar_RadarEventType;

  (function (Radar_RadarEventType) {
    Radar_RadarEventType[Radar_RadarEventType["RadarEventTypeNil"] = 0] = "RadarEventTypeNil";
    Radar_RadarEventType[Radar_RadarEventType["RadarEventTypeClickCount"] = 1] = "RadarEventTypeClickCount";
    Radar_RadarEventType[Radar_RadarEventType["RadarEventTypeViewDuration"] = 2] = "RadarEventTypeViewDuration";
    Radar_RadarEventType[Radar_RadarEventType["RadarEventTypeCompletionRate"] = 3] = "RadarEventTypeCompletionRate";
    Radar_RadarEventType[Radar_RadarEventType["RadarEventTypeShareCount"] = 4] = "RadarEventTypeShareCount";
    Radar_RadarEventType[Radar_RadarEventType["RadarEventTypeClosePageView"] = 5] = "RadarEventTypeClosePageView";
    Radar_RadarEventType[Radar_RadarEventType["RadarEventTypeOpenProductView"] = 6] = "RadarEventTypeOpenProductView";
    Radar_RadarEventType[Radar_RadarEventType["RadarEventTypeAddProduct2ShoppingCar"] = 7] = "RadarEventTypeAddProduct2ShoppingCar";
    Radar_RadarEventType[Radar_RadarEventType["RadarEventTypeOrderPaid"] = 8] = "RadarEventTypeOrderPaid";
  })(Radar_RadarEventType || (Radar_RadarEventType = {}));

  return Radar_RadarEventType;
}();
export var Radar_ModelMaterial_Status = function () {
  //__ENUM_IIFE__
  var Radar_ModelMaterial_Status;

  (function (Radar_ModelMaterial_Status) {
    Radar_ModelMaterial_Status[Radar_ModelMaterial_Status["StatusNil"] = 0] = "StatusNil";
    Radar_ModelMaterial_Status[Radar_ModelMaterial_Status["StatusEnable"] = 1] = "StatusEnable";
    Radar_ModelMaterial_Status[Radar_ModelMaterial_Status["StatusDisable"] = 2] = "StatusDisable";
  })(Radar_ModelMaterial_Status || (Radar_ModelMaterial_Status = {}));

  return Radar_ModelMaterial_Status;
}();
export var Radar_GetMaterialListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Radar_GetMaterialListReq_ListOption;

  (function (Radar_GetMaterialListReq_ListOption) {
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionTitle"] = 1] = "ListOptionTitle";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionCreatorUid"] = 2] = "ListOptionCreatorUid";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionCreatedAt"] = 3] = "ListOptionCreatedAt";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionStatus"] = 4] = "ListOptionStatus";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionMaterialType"] = 5] = "ListOptionMaterialType";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionCategoryId"] = 6] = "ListOptionCategoryId";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionSearch1"] = 7] = "ListOptionSearch1";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionSearch2"] = 8] = "ListOptionSearch2";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionSearch3"] = 9] = "ListOptionSearch3";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionSearch4"] = 10] = "ListOptionSearch4";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionEnableEvent"] = 11] = "ListOptionEnableEvent";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionReturnTag"] = 12] = "ListOptionReturnTag";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionProductChannelList"] = 13] = "ListOptionProductChannelList";
    Radar_GetMaterialListReq_ListOption[Radar_GetMaterialListReq_ListOption["ListOptionContentName"] = 14] = "ListOptionContentName";
  })(Radar_GetMaterialListReq_ListOption || (Radar_GetMaterialListReq_ListOption = {}));

  return Radar_GetMaterialListReq_ListOption;
}();
export var Radar_GetMaterialListForMpReq_ListOption = function () {
  //__ENUM_IIFE__
  var Radar_GetMaterialListForMpReq_ListOption;

  (function (Radar_GetMaterialListForMpReq_ListOption) {
    Radar_GetMaterialListForMpReq_ListOption[Radar_GetMaterialListForMpReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Radar_GetMaterialListForMpReq_ListOption[Radar_GetMaterialListForMpReq_ListOption["ListOptionTitle"] = 1] = "ListOptionTitle";
    Radar_GetMaterialListForMpReq_ListOption[Radar_GetMaterialListForMpReq_ListOption["ListOptionCreatedAt"] = 2] = "ListOptionCreatedAt";
    Radar_GetMaterialListForMpReq_ListOption[Radar_GetMaterialListForMpReq_ListOption["ListOptionMaterialType"] = 3] = "ListOptionMaterialType";
    Radar_GetMaterialListForMpReq_ListOption[Radar_GetMaterialListForMpReq_ListOption["ListOptionStatus"] = 4] = "ListOptionStatus";
  })(Radar_GetMaterialListForMpReq_ListOption || (Radar_GetMaterialListForMpReq_ListOption = {}));

  return Radar_GetMaterialListForMpReq_ListOption;
}();
export var Radar_GetVisitUserListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Radar_GetVisitUserListReq_ListOption;

  (function (Radar_GetVisitUserListReq_ListOption) {
    Radar_GetVisitUserListReq_ListOption[Radar_GetVisitUserListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Radar_GetVisitUserListReq_ListOption[Radar_GetVisitUserListReq_ListOption["ListOptionUserName"] = 2] = "ListOptionUserName";
    Radar_GetVisitUserListReq_ListOption[Radar_GetVisitUserListReq_ListOption["ListOptionUpdatedAt"] = 1] = "ListOptionUpdatedAt";
    Radar_GetVisitUserListReq_ListOption[Radar_GetVisitUserListReq_ListOption["ListOptionOrderLastVisitedAt"] = 3] = "ListOptionOrderLastVisitedAt";
  })(Radar_GetVisitUserListReq_ListOption || (Radar_GetVisitUserListReq_ListOption = {}));

  return Radar_GetVisitUserListReq_ListOption;
}();
export var Radar_ExportVisitUserListReq_ListOption = function () {
  //__ENUM_IIFE__
  var Radar_ExportVisitUserListReq_ListOption;

  (function (Radar_ExportVisitUserListReq_ListOption) {
    Radar_ExportVisitUserListReq_ListOption[Radar_ExportVisitUserListReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Radar_ExportVisitUserListReq_ListOption[Radar_ExportVisitUserListReq_ListOption["ListOptionUserName"] = 2] = "ListOptionUserName";
    Radar_ExportVisitUserListReq_ListOption[Radar_ExportVisitUserListReq_ListOption["ListOptionCreatedAt"] = 1] = "ListOptionCreatedAt";
  })(Radar_ExportVisitUserListReq_ListOption || (Radar_ExportVisitUserListReq_ListOption = {}));

  return Radar_ExportVisitUserListReq_ListOption;
}();
export var Radar_GetClickStatReq_DisplayType = function () {
  //__ENUM_IIFE__
  var Radar_GetClickStatReq_DisplayType;

  (function (Radar_GetClickStatReq_DisplayType) {
    Radar_GetClickStatReq_DisplayType[Radar_GetClickStatReq_DisplayType["DisplayTypeNil"] = 0] = "DisplayTypeNil";
    Radar_GetClickStatReq_DisplayType[Radar_GetClickStatReq_DisplayType["DisplayTypeHour"] = 1] = "DisplayTypeHour";
    Radar_GetClickStatReq_DisplayType[Radar_GetClickStatReq_DisplayType["DisplayTypeDay"] = 2] = "DisplayTypeDay";
  })(Radar_GetClickStatReq_DisplayType || (Radar_GetClickStatReq_DisplayType = {}));

  return Radar_GetClickStatReq_DisplayType;
}();
export var Radar_GetClickStatReq_ListOption = function () {
  //__ENUM_IIFE__
  var Radar_GetClickStatReq_ListOption;

  (function (Radar_GetClickStatReq_ListOption) {
    Radar_GetClickStatReq_ListOption[Radar_GetClickStatReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Radar_GetClickStatReq_ListOption[Radar_GetClickStatReq_ListOption["ListOptionCreatedAt"] = 1] = "ListOptionCreatedAt";
    Radar_GetClickStatReq_ListOption[Radar_GetClickStatReq_ListOption["ListOptionDisplayType"] = 2] = "ListOptionDisplayType";
  })(Radar_GetClickStatReq_ListOption || (Radar_GetClickStatReq_ListOption = {}));

  return Radar_GetClickStatReq_ListOption;
}();
export var Radar_GetViewStatReq_DisplayType = function () {
  //__ENUM_IIFE__
  var Radar_GetViewStatReq_DisplayType;

  (function (Radar_GetViewStatReq_DisplayType) {
    Radar_GetViewStatReq_DisplayType[Radar_GetViewStatReq_DisplayType["DisplayTypeNil"] = 0] = "DisplayTypeNil";
    Radar_GetViewStatReq_DisplayType[Radar_GetViewStatReq_DisplayType["DisplayTypeHour"] = 1] = "DisplayTypeHour";
    Radar_GetViewStatReq_DisplayType[Radar_GetViewStatReq_DisplayType["DisplayTypeDay"] = 2] = "DisplayTypeDay";
  })(Radar_GetViewStatReq_DisplayType || (Radar_GetViewStatReq_DisplayType = {}));

  return Radar_GetViewStatReq_DisplayType;
}();
export var Radar_GetViewStatReq_ListOption = function () {
  //__ENUM_IIFE__
  var Radar_GetViewStatReq_ListOption;

  (function (Radar_GetViewStatReq_ListOption) {
    Radar_GetViewStatReq_ListOption[Radar_GetViewStatReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Radar_GetViewStatReq_ListOption[Radar_GetViewStatReq_ListOption["ListOptionCreatedAt"] = 1] = "ListOptionCreatedAt";
    Radar_GetViewStatReq_ListOption[Radar_GetViewStatReq_ListOption["ListOptionDisplayType"] = 2] = "ListOptionDisplayType";
  })(Radar_GetViewStatReq_ListOption || (Radar_GetViewStatReq_ListOption = {}));

  return Radar_GetViewStatReq_ListOption;
}();
export var Radar_GetTimeLineListSysReq_ListOption = function () {
  //__ENUM_IIFE__
  var Radar_GetTimeLineListSysReq_ListOption;

  (function (Radar_GetTimeLineListSysReq_ListOption) {
    Radar_GetTimeLineListSysReq_ListOption[Radar_GetTimeLineListSysReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
  })(Radar_GetTimeLineListSysReq_ListOption || (Radar_GetTimeLineListSysReq_ListOption = {}));

  return Radar_GetTimeLineListSysReq_ListOption;
}();
export var Radar_BatchSetProductMaterialRadarEventListReq_Type = function () {
  //__ENUM_IIFE__
  var Radar_BatchSetProductMaterialRadarEventListReq_Type;

  (function (Radar_BatchSetProductMaterialRadarEventListReq_Type) {
    Radar_BatchSetProductMaterialRadarEventListReq_Type[Radar_BatchSetProductMaterialRadarEventListReq_Type["TypeNil"] = 0] = "TypeNil";
    Radar_BatchSetProductMaterialRadarEventListReq_Type[Radar_BatchSetProductMaterialRadarEventListReq_Type["TypeMaterIalIdList"] = 1] = "TypeMaterIalIdList";
    Radar_BatchSetProductMaterialRadarEventListReq_Type[Radar_BatchSetProductMaterialRadarEventListReq_Type["TypeAll"] = 2] = "TypeAll";
  })(Radar_BatchSetProductMaterialRadarEventListReq_Type || (Radar_BatchSetProductMaterialRadarEventListReq_Type = {}));

  return Radar_BatchSetProductMaterialRadarEventListReq_Type;
}();
export var Radar_GetShareStatReq_DisplayType = function () {
  //__ENUM_IIFE__
  var Radar_GetShareStatReq_DisplayType;

  (function (Radar_GetShareStatReq_DisplayType) {
    Radar_GetShareStatReq_DisplayType[Radar_GetShareStatReq_DisplayType["DisplayTypeNil"] = 0] = "DisplayTypeNil";
    Radar_GetShareStatReq_DisplayType[Radar_GetShareStatReq_DisplayType["DisplayTypeHour"] = 1] = "DisplayTypeHour";
    Radar_GetShareStatReq_DisplayType[Radar_GetShareStatReq_DisplayType["DisplayTypeDay"] = 2] = "DisplayTypeDay";
  })(Radar_GetShareStatReq_DisplayType || (Radar_GetShareStatReq_DisplayType = {}));

  return Radar_GetShareStatReq_DisplayType;
}();
export var Radar_GetShareStatReq_ListOption = function () {
  //__ENUM_IIFE__
  var Radar_GetShareStatReq_ListOption;

  (function (Radar_GetShareStatReq_ListOption) {
    Radar_GetShareStatReq_ListOption[Radar_GetShareStatReq_ListOption["ListOptionNil"] = 0] = "ListOptionNil";
    Radar_GetShareStatReq_ListOption[Radar_GetShareStatReq_ListOption["ListOptionCreatedAt"] = 1] = "ListOptionCreatedAt";
    Radar_GetShareStatReq_ListOption[Radar_GetShareStatReq_ListOption["ListOptionDisplayType"] = 2] = "ListOptionDisplayType";
  })(Radar_GetShareStatReq_ListOption || (Radar_GetShareStatReq_ListOption = {}));

  return Radar_GetShareStatReq_ListOption;
}();